
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getMunicipalitySlugsFromCity",
      resolverType: "query",
      routePath: "/getMunicipalitySlugsFromCity",
      httpMethod: "POST",
    });
  